<template>
  <section>
    <ViewHeader>
      <template #title>{{ $t('layouts.layout_profile.title') }}</template>
      <template #intro>{{ $t('layouts.layout_profile.intro') }}</template>
    </ViewHeader>

    <div class="container view-body view-body--padded">
      <div class="row justify-content-md-around">
        <div class="col-md-auto text-center">
            <nav class="nav nav-pills nav-pills-profile flex-column flex-md-row">
              <b-nav-item class="flex-fill text-center nav-link" :to="{ name: 'profile-resume'}">
                {{ $t('menu.profile_resume') }}
              </b-nav-item>

              <b-nav-item class="flex-fill text-center nav-link" :to="{ name: 'profile-privacy'}">
                {{ $t('menu.profile_privacy') }}
              </b-nav-item>

              <b-nav-item class="flex-fill text-center nav-link" :to="{ name: 'profile-change-password'}">
                {{ $t('menu.profile_change_password') }}
              </b-nav-item>
            </nav>

          </div>
        </div>

        <div class="col-12 mt-6">
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import ViewHeader from '@/components/ViewHeader'

export default {
  components: {
    ViewHeader
  }
}
</script>